/**
 * Cinema FX bus — dispatches global UI events for tactile reward animations.
 * Listened to by <CinemaFX /> mounted at the app root.
 */

export type TicketTearDetail = {
  title?: string;
  posterPath?: string | null;
  // Optional viewport origin (page coords) so the ticket flies from the clicked element
  originX?: number;
  originY?: number;
};

export type CreditsRollDetail = {
  title?: string;
  originX?: number;
  originY?: number;
};

const TICKET_EVENT = "swiftix:ticket-tear";
const CREDITS_EVENT = "swiftix:credits-roll";

const reducedMotion = () =>
  typeof window !== "undefined" &&
  window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;

export function tearTicket(detail: TicketTearDetail = {}) {
  if (typeof window === "undefined" || reducedMotion()) return;
  window.dispatchEvent(new CustomEvent(TICKET_EVENT, { detail }));
}

export function rollCredits(detail: CreditsRollDetail = {}) {
  if (typeof window === "undefined" || reducedMotion()) return;
  window.dispatchEvent(new CustomEvent(CREDITS_EVENT, { detail }));
}

export const CINEMA_FX_EVENTS = {
  ticket: TICKET_EVENT,
  credits: CREDITS_EVENT,
} as const;
